<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>VGM Detail</h2>
            <md-layout md-flex="45"></md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-s" v-if="vgmArrayList.length==0" />
        <div v-if="vgmArrayList.length==0 || vgmModel.conffVgmId!=''">
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Client Name</label>
                <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName" v-model="vgmModel.clientName"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="20"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Client Registration / License No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientRegistrationNo"
                  name="clientRegistrationNo"
                  v-model="vgmModel.clientRegistrationNo"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.clientRegistrationNo"
              >{{errorVgmList.clientRegistrationNo}}</span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="50">
              <md-layout md-flex="100">
                <label>Name and Registration of official of the client authorized to sign document</label>
                <b-form-input :formatter="capitalizeAll"
                  id="nameRegistrationOfficial"
                  name="nameRegistrationOfficial"
                  v-model="vgmModel.nameRegistrationOfficial"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.nameRegistrationOfficial"
              >{{errorVgmList.nameRegistrationOfficial}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>24*7 contact No. of authorized official of client</label>
                <b-form-input :formatter="capitalizeAll"
                  id="officialContactNo"
                  name="officialContactNo"
                  v-model="vgmModel.officialContactNo"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.officialContactNo"
              >{{errorVgmList.officialContactNo}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label for="containerNo">Container No</label>
                <b-form-input :formatter="capitalizeAll" v-model="vgmModel.containerNo" disabled></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label for="containerTypeId">Container Size ( TEU/FEU/Other)</label>
              <model-list-select
                :list="ContainerTypeList"
                v-model="vgmModel.containerTypeId"
                option-value="containerTypeId"
                option-text="containerType"
                placeholder="Select Container Type/Size"
                :isDisabled="true"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <label for="containerTypeId">Container Type</label>
              <model-list-select
                :list="ContainerTypeList"
                v-model="vgmModel.containerTypeId"
                option-value="containerTypeId"
                option-text="containerType"
                placeholder="Select Container Type/Size"
                :isDisabled="true"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label for="containerNo">Container Size ( TEU/FEU/Other)</label>
                <b-form-input :formatter="capitalizeAll" v-model="vgmModel.sizeTeu"></b-form-input>
              </md-layout>
            </md-layout>-->
          </md-layout>

          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="50">
              <md-layout md-flex="100">
                <label>Maximum permissible weight of container as per the CSC plate</label>
                <b-form-input :formatter="capitalizeAll"
                  id="maxPermissibleWeight"
                  name="maxPermissibleWeight"
                  v-model="vgmModel.maxPermissibleWeight"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.maxPermissibleWeight"
              >{{errorVgmList.maxPermissibleWeight}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Verfiied Gross mass of container(Method 1/2)</label>
                <b-form-input :formatter="capitalizeAll"
                  id="verifiedConGrossMass"
                  name="verifiedConGrossMass"
                  v-model="vgmModel.verifiedConGrossMass"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.verifiedConGrossMass"
              >{{errorVgmList.verifiedConGrossMass}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <label>Date & time of Weighing</label>
              <date-picker
                lang="en"
                name="weighingDate"
                id="weighingDate"
                type="datetime"
                format="YYYY-MM-DD hh:mm a"
                :minute-step="1"
                v-model="vgmModel.weighingDate"
              ></date-picker>
              <span class="error" v-if="!vgmModel.weighingDate">{{errorVgmList.weighingDate}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Weighing Slip No</label>
                <b-form-input :formatter="capitalizeAll"
                  id="weighingSlipNo"
                  name="weighingSlipNo"
                  v-model="vgmModel.weighingSlipNo"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!vgmModel.weighingSlipNo">{{errorVgmList.weighingSlipNo}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Weighbridge Registration No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="weighbridgeRegNo"
                  name="weighbridgeRegNo"
                  v-model="vgmModel.weighbridgeRegNo"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!vgmModel.weighingSlipNo">{{errorVgmList.weighbridgeRegNo}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Weighbridge Address</label>
                <b-form-input :formatter="capitalizeAll"
                  id="weighbridgeAddress"
                  name="weighbridgeAddress"
                  v-model="vgmModel.weighbridgeAddress"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!vgmModel.weighbridgeAddress"
              >{{errorVgmList.weighbridgeAddress}}</span>
            </md-layout>
          </md-layout>

          <hr class="hr-border" />
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <!-- <h4 style="padding:0px;margin:0px"></h4> -->
              <label for="autoCommodity">Commodity</label>
              <model-list-select
                :list="commodityList"
                v-model="ffExoprtDetail.commodityId"
                option-value="commodityId"
                option-text="itemDescription"
                placeholder="Select Commodity"
                :isDisabled="true"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label for="commodityType">Commodity Type</label>

                <b-form-input :formatter="capitalizeAll"
                  id="commodityType"
                  name="commodityType"
                  disabled
                  v-model="ffExoprtDetail.commodityType"
                ></b-form-input>

                <!-- <md-select
                name="commodityType"
                id="commodityType"
                v-model="ffExoprtDetail.commodityType"
              >
                 <md-option
                  v-for="(item,index) in getCommodityData"
                  :key="index"
                  :value="item.commodityId"
                >{{item.commodityType}}</md-option>
                </md-select>-->
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label for="itemDescription">Item Description</label>

                <b-form-textarea :formatter="capitalizeAll"
                  id="itemDescription"
                  name="itemDescription"
                  disabled
                  v-model="ffExoprtDetail.itemDescription"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.commodityType=='Hazardous'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>IMDG Class</label>
                <b-form-input :formatter="capitalizeAll"
                  id="IMDGClass"
                  name="IMDGClass"
                  v-model="ffExoprtDetail.IMDGClass"
                  disabled
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>UN Number</label>
                <b-form-input :formatter="capitalizeAll"
                  id="UNNumber"
                  name="UNNumber"
                  v-model="ffExoprtDetail.UNNumber"
                  disabled
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Packing Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="packingCode"
                  name="packingCode"
                  v-model="ffExoprtDetail.packingCode"
                  disabled
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-s" />
          <md-layout md-gutter>
            <md-layout md-flex="45"></md-layout>
            <md-layout md-flex="30">
              <md-button
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                @click="addVGM"
                id="addButtonLoader1"
              >{{vgmModel.conffVgmId != ""?"Edit":"Add"}} VGM</md-button>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </div>
        <hr class="hr-border" v-if="vgmArrayList.length>0" />
        <div class="box" v-if="vgmArrayList.length>0">
          <div class="box-header">
            <h3 class="box-title">
              <u>VGM Details</u>
            </h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="poTablefdfdf" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Client Name</th>
                  <th>ContainerNo</th>
                  <th>Container Type</th>

                  <th>Edit</th>
                  <th>Print</th>
                  <th>Download Word</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in vgmArrayList" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.clientName}}</td>
                  <td>{{item.containerNo}}</td>
                  <td>{{item.containerType}}</td>
                  <td>
                    <md-button class="md-icon-button md-raised md-dense" @click="viewEdit(item)">
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item.uploadVgm)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="downloadWord(item.conffVgmId)"
                    >
                      <md-icon>cloud_download</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/fclConsoVgm");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      excelUpload: "",
      vgmModel: {
        ffVgmId: "",
        conffVgmId: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        clientName: "PRIDEL",
        clientId: "",
        containerType: "",
        sizeTeu: "",
        ffExecutionContainerId: "",
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        containerNo: "",
        containerTypeId: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: "",
        commodityId: ""
      },

      errorVgmList: {
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: ""
      },
      arrayErrorVgm: [
        "Enter regristration No",
        "Enter Contact no",
        "Enter name registration",
        "Enter max permissible weight",
        "Enter verified gross mass",
        "Select weighing Date",
        "Enter weighing slip no",
        "Enter weight brigde regd No",
        "Enter weight bridge address"
      ],

      removeVmodel: {
        weighingSlipNo: "",

        containerNo: "",
        containerTypeId: "",
        ffExecutionContainerId: "",
        ffVgmId: ""
      },
      ffConExectionData: [],
      vgmArrayList: [],
      CommodityAll: {},
      getCommodityData: ["zim"],
      ALLFclData: ["zim"],

      getContainerTypeData: ["zim"],
      validate: true,
      portCodeError: "",
      deleteId: "",
      ffExoprtDetail: {
        commodityId: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        commodityType: "",
        itemDescription: "",
        fclConsoMultipleClientId: ""
      }
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    // vgmModel: {
    //   handler: function(newVal, oldVal) {
    //     console.log("Here Change obj", newVal, oldVal);
    //     if (newVal.ffExecutionContainerId != "") {
    //       let arrayNewContainer = this.containerNoName.filter(x => {
    //         return x.ffExecutionContainerId == newVal.ffExecutionContainerId;
    //       });
    //       if (arrayNewContainer.length > 0) {
    //         this.vgmModel.containerTypeId =
    //           arrayNewContainer[0].containerTypeId;
    //         this.vgmModel.containerType = arrayNewContainer[0].containerType;
    //       }
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    }
  },

  methods: {
    downloadWord(id) {
      window.location =
        "http://164.52.196.219/pridelApiNew/Freight/wordVGM.php?id=" +
        id +
        "&tableId=conffVgmId" +
        "&tableName=con_fcl_vgm";
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      window.open(`${this.docURL}/vgmDetail/` + item);
    },
    viewEdit(item) {
      let arrayFilter = this.vgmArrayList.filter(x => {
        return x.conffVgmId == item.conffVgmId;
      });

      Object.keys(this.vgmModel).map(x => {
        this.vgmModel[x] = arrayFilter[0][x] || "";
      });
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToVgmFFConsoEx.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.FullwhExecData.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            }
            if (data.CommodityData.length > 0) {
              this.getCommodityData = data.CommodityData;
            }

            if (data.FullfclDetails.length > 0) {
              this.ALLFclData = data.FullfclDetails;
              Object.keys(this.ffExoprtDetail).map(x => {
                this.ffExoprtDetail[x] = data.FullfclDetails[0][x] || "";
              });

              let item = this.getCommodityData.filter(x => {
                return x.commodityId == data.FullfclDetails[0]["commodityId"];
              })[0];

              this.ffExoprtDetail.commodityType = item.commodityType;
              this.ffExoprtDetail.itemDescription = item.itemDescription;
            }

            if (data.vgmTableDetails.length > 0) {
              this.vgmArrayList = data.vgmTableDetails;
            } else {
              this.vgmModel.containerNo =
                data.FullwhExecData[0].fclConcontainerNo;
              this.vgmModel.containerTypeId =
                data.FullwhExecData[0].containerTypeId;
              this.vgmModel.containerType =
                data.FullwhExecData[0].containerType;
            }

            // console.log("fdsfdsfvdsfsdfdsfsd");
            // console.log(this.vgmArrayList)
            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;

      //  console.log(this.ffExoprtDetail.commodityType, "jitu");
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      this.$router.push({
        path: "/ffExportCon/executionWHStuffingIcdCon"
      });
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.vgmModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addVGM() {
      this.validateVGM();

      let newData = {
        vgmModel: this.vgmModel,
        ffExoprtDetail: this.ffExoprtDetail
      };

      // return false;
      // this.validateAddVehicleSizeForm();
      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addVgmConsoFCL.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            // $("#addButtonLoader1").css("display", "block");
            // $("#loader1").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              //  window.location.reload(true);
              if (this.vgmModel.conffVgmId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.vgmModel).map(x => {
                this.vgmModel[x] = "";
              });
              this.getData();

              this.$refs["addPop"].open();
            }
          })
          .catch(error => {});
      }
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {}
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// fclConsoVgm.vue?15d55b79